module.exports = __webpack_public_path__ + "764d2ebde3d9f3db2094a1737fb0596f.png";